"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LockIconWrapper = exports.CheckboxContainer = exports.StyledWrapper = exports.StyledValue = exports.StyledVariantsButton = exports.StyledRange = exports.StyledVariantsBlock = exports.StyledVariantsWrapper = exports.StyledResetButton = exports.StyledEmptyVariants = exports.StyledVariants = exports.StyledVariant = exports.StyledSearch = void 0;
const vobaza_ui_inputs_input_text_1 = require("@nebo-team-dev/vobaza.ui.inputs.input-text");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSearch = (0, styled_components_1.default)(vobaza_ui_inputs_input_text_1.InputText) `
  width: 100%;
  min-height: 40px;
  font-weight: 500;
  padding: 4px 40px 4px 12px;
  height: 40px;
  position: relative;

  & label {
    font-size: 8px;
  }
`;
exports.StyledVariant = styled_components_1.default.button `
  display: block;
  width: 100%;
  padding: 4px 12px;
  background: transparent;
  border: none;

  font-size: 16px;
  line-height: 24px;
  text-align: left;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    background: var(--light-primary-color, #e1ebfd);
  }

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &[data-variation='secondary'] {
    padding: 8px 12px;
    font-size: 14px;
    line-height: 1;

    &:hover {
      background: transparent;
      color: var(--primary-color, #367bf5);
    }
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
`;
exports.StyledVariants = styled_components_1.default.div `
  position: absolute;
  top: calc(100% + 2px);
  left: ${(props) => (props.right ? 'initial' : 0)};
  right: ${(props) => (props.right ? 0 : 'initial')};
  display: ${(props) => (props.show ? 'block' : 'none')};
  width: max-content;
  border-radius: 8px;

  background: #fff;
  box-shadow: 0px 4px 8px rgba(138, 118, 92, 0.16);
  overflow: hidden;
  transition: 0.3s;

  &[data-variation='secondary'] {
    min-width: 220px;
    max-width: 264px;
    /* border-radius: 0; */
    box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.15);
  }
`;
exports.StyledEmptyVariants = styled_components_1.default.p `
  padding: 8px;
  margin: 0;
  font-size: 14px;
`;
exports.StyledResetButton = styled_components_1.default.div `
  font-weight: 400;
  color: var(--primary-color, #367bf5);
  margin: 4px 0;

  padding: 0 10px;
  cursor: pointer;
`;
exports.StyledVariantsWrapper = styled_components_1.default.div `
  width: 100%;
  padding: 12px 0;
  max-height: 252px;
`;
exports.StyledVariantsBlock = styled_components_1.default.div `
  max-height: 180px;
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
    margin-right: 4px;
  }
  &::-webkit-scrollbar-track {
    background-color: #ebebeb;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #909090;
    border-radius: 8px;
  }
`;
exports.StyledRange = styled_components_1.default.div `
  padding: 8px 16px;
  overflow: auto;
`;
exports.StyledVariantsButton = styled_components_1.default.div `
  padding: 0 12px 12px;

  button {
    margin-left: auto;
  }
`;
exports.StyledValue = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  padding: 7px 15px;
  border: 1px solid #ebebeb;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;

  svg {
    margin-left: 10px;
    color: var(--primary-color, #367bf5);
  }

  &[data-variation='secondary'] {
    padding: 4px 11px 4px 15px;
    background-color: #f2f2f2;
    border-color: #f2f2f2;
    transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out;

    &:hover {
      background-color: #d9d9d9;
      border-color: #d9d9d9;
    }

    svg {
      height: 18px;
      margin-left: 4px;
      color: inherit;
    }
  }
`;
exports.StyledWrapper = styled_components_1.default.div `
  position: relative;
  z-index: 1;
  height: 40px;

  font-size: 16px;
  line-height: 24px;
  color: #212121;

  outline: none;
  user-select: none;
  transition: 0.3s;
  z-index: 3;

  &[data-variation='secondary'] {
    height: 28px;
    font-size: 12px;
    line-height: 1;
  }

  &[data-active='true'] {
    z-index: 10;
  }
`;
exports.CheckboxContainer = styled_components_1.default.div `
  position: relative;
`;
exports.LockIconWrapper = styled_components_1.default.div `
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  display: flex;
  background: white;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
`;
//# sourceMappingURL=filter-select.styled.js.map